import React, { useEffect, useState } from "react";
import MainPart from "./MainPart";
import GroupsFeeds from "./GroupsFeeds";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";
import { useNavigate } from "react-router-dom";
import MobilesTabs from "./MobilesTabs";
import {
  groupDetail,
  groupsListing,
  LeaveGroup,
} from "src/DAL/Community/Community";
import { Button, CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomPopoverNew from "src/components/CustomPopoverNew";
import { s3baseUrl } from "src/config/config";
import { Icon } from "@iconify/react";
import { useSnackbar } from "notistack";
import CustomConfirmation from "src/components/GeneralComponents/CustomConfirmation";
import { show_proper_words } from "src/utils/constants";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function Feed() {
  const { enqueueSnackbar } = useSnackbar();
  const { selectedGroup, setSelectedGroup } = useContentSetting();
  const classes = useStyles();
  const [showInfoBox, setShowInfoBox] = useState(false);
  const { userInfo } = useContentSetting();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openGroup, setOpenGroup] = useState(false);
  const [communityGroup, setCommunityGroup] = useState(null);
  const [isGroupLoad, setIsisGroupLoad] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const getGroupsListing = async () => {
    const result = await groupsListing();
    if (result.code == 200) {
      const savedGroupId = localStorage.getItem("selectedGroup");
      const communityGroups = result?.community_groups || [];

      let initialGroupId = "";

      if (savedGroupId) {
        initialGroupId = savedGroupId === "general" ? "" : savedGroupId;
      } else if (communityGroups.length > 0) {
        initialGroupId = communityGroups[0]._id;
        localStorage.setItem("selectedGroup", initialGroupId);
      }

      setSelectedGroup(initialGroupId);
      setData(communityGroups);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const getGroupDetail = async (id) => {
    setIsisGroupLoad(true);
    const result = await groupDetail(id);
    if (result.code === 200) {
      setCommunityGroup(result.community_group);
      setIsisGroupLoad(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsisGroupLoad(false);
    }
  };

  const handleMyPosts = () => {
    if (selectedGroup) {
      navigate(`/my-posts`, { state: { _id: selectedGroup } });
    } else {
      navigate(`/my-posts`);
    }
  };

  const handleGroupLeave = async () => {
    setOpenDelete(false);
    setOpenGroup(false);
    const result = await LeaveGroup(communityGroup.community_group_slug);
    if (result.code === 200) {
      localStorage.removeItem("selectedGroup");
      setSelectedGroup("");
      setData((prevData) =>
        prevData.filter(
          (group) =>
            group.community_group_slug !== communityGroup.community_group_slug,
        ),
      );
      enqueueSnackbar("You have Successfully left the Group", {
        variant: "success",
      });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  useEffect(() => {
    getGroupsListing();
  }, []);

  useEffect(() => {
    if (openGroup) {
      getGroupDetail(selectedGroup);
    }
  }, [selectedGroup, openGroup]);

  let name_group = data.find((id) => id._id === selectedGroup);

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div className="container-fluid new-community-page">
      <div className="row d-none d-lg-flex mt-3">
        <div className="col-lg-6 col-sm-12">
          <h2>
            {name_group?.title
              ? show_proper_words(name_group.title)
              : "General Community"}
          </h2>
        </div>
        <div className="col-lg-6 col-sm-12 text-end">
          <Button variant="contained" onClick={handleMyPosts}>
            My Posts
          </Button>
          {selectedGroup && (
            <>
              <Button
                className="ms-2"
                variant="contained"
                onClick={() => {
                  setOpenGroup(true);
                }}
              >
                {isGroupLoad ? "Loading..." : "Group Detail"}
              </Button>
            </>
          )}
        </div>
      </div>
      <div className="mobile-case d-block d-lg-none">
        {window.screen.width < 911 && (
          <div className="row mt-3">
            <div className={`community-main-section pb-4 col-12`}>
              <MobilesTabs
                showInfoBox={showInfoBox}
                setShowInfoBox={setShowInfoBox}
                userInfo={userInfo}
                event_id=""
                handleMyPosts={handleMyPosts}
                data={data}
                name_group={name_group}
              />
            </div>
          </div>
        )}
      </div>
      <div className="row d-none d-lg-flex mt-3">
        <div className={`community-main-section pb-4 col-8`}>
          <MainPart
            showInfoBox={showInfoBox}
            setShowInfoBox={setShowInfoBox}
            userInfo={userInfo}
            event_id=""
          />
        </div>
        <div className="col-4">
          <GroupsFeeds data={data} />
        </div>
      </div>
      <CustomConfirmation
        open={openDelete}
        setOpen={setOpenDelete}
        title={"Are you sure you want to Leave this Group?"}
        handleAgree={handleGroupLeave}
      />
      {communityGroup && (
        <CustomPopoverNew
          isOpenPop={openGroup}
          isClosePop={setOpenGroup}
          title={communityGroup.title}
          componentToPassDown={
            <div className="p-4">
              <div className="card-body">
                <div className="row">
                  <div className="col-2">
                    <img
                      width={120}
                      height="auto"
                      src={s3baseUrl + communityGroup?.image?.thumbnail_1}
                      alt="Group Image"
                      className="img-fluid"
                    />
                  </div>
                  <div className="col-10">
                    <p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: communityGroup.description,
                        }}
                      ></div>
                    </p>
                  </div>
                  <div className="col-12 text-end mt-3">
                    <Button
                      className="ms-2"
                      variant="contained"
                      onClick={() => {
                        setOpenDelete(true);
                      }}
                    >
                      <Icon className="exit-icon" icon={"ion:exit-outline"} />
                      Leave Group
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          }
        />
      )}
    </div>
  );
}
